
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const Canonical = ({ url }) => (
  <Helmet>
    <link rel="canonical" href={url} />
  </Helmet>
);

Canonical.propTypes = {
  url: PropTypes.string.isRequired,
};

export default Canonical;

